import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-排序",
  "use": "icon-排序-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-排序\"><defs><style type=\"text/css\"></style></defs><path d=\"M416.64 927.104H259.584V364.224H67.84l348.8-299.968v862.848zM610.56 97.088h157.056v560.128h191.744l-348.8 299.904V97.088z\" p-id=\"4541\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/排序.svg
// module id = knFW
// module chunks = 54